import React from 'react';
import { useAuth } from '../context/AuthContext';
import LoadingSpinner from './LoadingSpinner';
import { formatCurrency } from '../utils/format';

const getInitials = (name = '') =>
  name
    .split(' ')
    .map((n) => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);

function Profile() {
  const { isLoading, user } = useAuth();

  if (isLoading) {
    return <LoadingSpinner text="Loading profile..." />;
  }

  if (!user) return null;

  const updatedAt = user.updated_at
    ? new Date(user.updated_at).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      })
    : 'N/A';

  return (
    <>
      <div className="client-page-head">
        <h1 className="client-page-title">Profile</h1>
        <p className="client-page-sub">Your account details</p>
      </div>

      <div className="c-card c-card-pad">
        <div className="c-profile-hero">
          <div className="c-profile-avatar">
            {user.picture ? (
              <img src={user.picture} alt={user.name} />
            ) : (
              <span>{getInitials(user.name)}</span>
            )}
          </div>
          <div>
            <h2 className="c-profile-name">{user.name}</h2>
            <p className="c-profile-role">Investor</p>
          </div>
          <span className="c-profile-badge">ACTIVE</span>
        </div>

        <div className="c-info-grid">
          <div className="c-info-item">
            <label>Email</label>
            <span>{user.email}</span>
          </div>
          <div className="c-info-item">
            <label>Contributed capital</label>
            <span>{formatCurrency(user.contributed_capital)}</span>
          </div>
          <div className="c-info-item">
            <label>Last updated</label>
            <span>{updatedAt}</span>
          </div>
        </div>
      </div>
    </>
  );
}

export default Profile;
